import React from 'react';
import '../css/insuranceguided.css';
import { Link } from 'react-router-dom';
import lifepolicy from '../assets/lifepolicy.webp';
import homepolicy from '../assets/homepolicy.webp';
import carinsuranceherobanner from '../assets/carinsuranceherobanner.webp';
import { Helmet } from 'react-helmet-async';

const InsuranceGuided = () => {
  return (
    <div className="insuranceguide-page-container">
      <Helmet>
        <title>Insurance Benefits | Clarity in Insurance | Policy Samjho</title>
        <meta
          name="description"
          content="Explore the key insurance benefits with Policy Samjho. We provide clarity in insurance by breaking down complex terms and offering personalized policy insights."
        />
        <meta
          name="keywords"
          content="insurance benefits, clarity in insurance, policy insights, insurance guidance, understand insurance policy, insurance policy help"
        />
        <link rel="canonical" href="https://policysamjho.com/insurance-benefits" />
        
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Insurance Benefits",
            "description": "Explore how Policy Samjho offers clear, jargon-free insurance benefits that help you choose the right policy with confidence and ease.",
            "provider": {
              "@type": "Organization",
              "name": "Policy Samjho",
              "url": "https://policysamjho.com"
            },
            "serviceType": "Insurance Guidance & Policy Insights",
            "areaServed": "IN",
            "url": "https://policysamjho.com/insurance-benefits",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "18003157480",
              "email": "info@policysamjho.com",
              "contactType": "customer service"
            }
          })}
        </script>
      </Helmet>

      <div className="insuranceguide-header">
        <div className="insuranceguide-header-left">
          <p className="insuranceguide-learn-about-text"> LEARN ABOUT INSURANCE YOUR WAY </p>
          <h1 className="insuranceguide-main-title">Insurance Benefits: Guided by Clarity.</h1>
        </div>
        <div className="insuranceguide-header-right">
          <p className="insuranceguide-description-text">
            At Policy Samjho, we believe insurance shouldn't be confusing.
            Our mission is to empower every Indian with simple, structured,
            and jargon-free knowledge—so you can understand, compare,
            and choose the right plan with confidence.
          </p>

          <Link to="/car-insurance-consultation" className="insurance-renewal-flash-button-header">
            <span className="renewal-text">Car Insurance Renewal</span>
            <span className="renewal-new-tag">Click Here</span>
          </Link>

        </div>
      </div>

      <div className="insuranceguide-container">
        <Link to="/life-insurance-advice" className="insuranceguide-card">
          <div className="insuranceguide-image-container">
            <img src={lifepolicy} alt="Life Insurance" />
          </div>
          <div className="insuranceguide-card-content">
            <div className="insuranceguide-text-content">
              <h3>Term Insurance</h3>
              <p className="insuranceguide-policyguidedcard-description">
                We help you understand how to protect your loved
                ones and plan for their financial security.
              </p>
            </div>
          </div>
        </Link>
        <Link to="/health-insurance-guidance" className="insuranceguide-card">
          <div className="insuranceguide-image-container">
            <img src={homepolicy} alt="Health Insurance" />
          </div>
          <div className="insuranceguide-card-content">
            <div className="insuranceguide-text-content">
              <h3>Health Insurance</h3>
              <p className="insuranceguide-policyguidedcard-description">
                We break down health plans, helping you choose
                the right coverage for your family's well-being.
              </p>
            </div>
          </div>
        </Link>
        <Link to="/car-insurance-consultation" className="insuranceguide-card">
          <div className="insuranceguide-image-container">
            <img src={carinsuranceherobanner} alt="General Insurance" />
          </div>
          <div className="insuranceguide-card-content">
            <div className="insuranceguide-text-content">
              <h3>Car Insurance</h3>
              <p className="insuranceguide-policyguidedcard-description">
                From vehicles to gadgets and travel—we decode
                how to protect what you own from everyday risks.
              </p>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default InsuranceGuided;